
<template>
    <!-- 账单 -->
    <div class="centers" v-loading="loading">
        <div v-for="(item, index) in dataList" :key="index" class="perTab">
            <div class="clearfix">
                <p class="floatL" style="line-height:32px">{{item.start_time}} ~ {{item.end_time}}</p>
                <p class="floatR"><el-button type="button" size="small" class="violet" icon="el-icon-download" @click="export2Excel(index)">Export(excel)</el-button></p>
                <p class="floatR blue" style="line-height:32px; margin-right:12px;" v-if="item.isFirst==='No'">Settled</p>
            </div>
            <el-table
                :data="item.list"
                :height="item.open?49*(item.list.length+1):250"

                border
                style="width: 100%">
                <el-table-column prop="project" label="Item"></el-table-column>
                <el-table-column prop="used" label="Usage"></el-table-column>
                <el-table-column prop="total" label="Actual amount"></el-table-column>
            </el-table>
            <div class="operateTab clearfix">
                <p class="floatL">
                    <el-button type="text" icon="el-icon-tickets" @click="item.open=true" v-show="!item.open">More</el-button>
                    <el-button type="text" icon="el-icon-tickets" @click="item.open=false" v-show="item.open">Shrink</el-button>
                </p>
                <p class="floatR" style="line-height: 40px;"><span>Amount spent:￥</span><span>{{item.amount}}</span></p>
            </div>
        </div>
        <!-- 分页 -->
        <div class="block"  style="text-align: center;margin-top:2em">
            <el-pagination
            @size-change="handelSizechange"
            @current-change="handelCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalcount">
            <!-- 总条数this.totalcount=数据传过来的数量 -->
            </el-pagination>
        </div>
    </div>
</template>
<script>
import Blob from '../../../excel/Blob'
import Export2Excel from '../../../excel/Export2Excel.js'
import {getBill} from '../api/finance'
import { getToken } from '../../utils/auth'
import store from '@/store'

export default {
  data () {
    return {
      dataList: [

      ],
      headers: ['STORAGE（CBM）', 'Sku', 'item', 'Packing Material', 'Insurance', 'Overweight Charge', 'Transaction service fee', 'Add On Service', 'Restocking', 'Mislaneous'],
      // 分页
      customer_id: '',
      pageNum: 1,
      pageSize: 10,
      totalcount: 0,
      loading: false
    }
  },
  beforeCreate () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }
  },
  created () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }
    this.getList()
  },
  methods: {
    getList () {
      const _this = this
      const params = {
        customer_id: this.customer_id,
        page: this.pageNum,
        pagesize: this.pageSize
      }
      this.loading = true
      getBill(params).then(response => {
        if (response.data.ask === 1) {
          if (response.data.data instanceof Array) {
            _this.dataList = this.handleData(response.data.data)
          } else if (response.data.data instanceof Object) {
            let array = []
            array.push(response.data.data)
            _this.dataList = this.handleData(array)
          }

          _this.totalcount = parseInt(response.data.total)
        } else {
          _this.dataList = []
          _this.totalcount = 0
        }
        this.loading = false
      }).catch(err => {
        _this.totalcount = 0
        console.log(err)
        this.loading = false
      })
    },
    // 处理数据
    handleData (data) {
      const _this = this
      data.forEach(function (value, index) {
        if (index === 0) {
          value.open = true
        } else {
          value.open = false
        }
        value.list.forEach(function (val, indexs) {
          val.project = _this.headers[indexs]
        })
      })
      return data
    },
    handelCurrentChange () {
      this.getList()
    },
    handelSizechange () {
      this.getList()
    },
    // 下载表格
    export2Excel (index) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../excel/Export2Excel')
        const tHeader = ['Item', 'Usage', 'Actual amount']
        // 上面设置Excel的表格第一行的标题
        const filterVal = ['project', 'used', 'total']
        // 上面的index、phone_Num、school_Name是tableData里对象的属性
        const list = this.dataList[index].list // 把data里的tableData存到list
        const tabName = this.dataList[index].start_time + ' - ' + this.dataList[index].end_time + ' bill'
        // 需要把 账号状态和运行时间间隔字段转换成汉字形式。
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, tabName)
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>
<style scoped>
    .centers{
        min-height: 100px;
        text-align: left;
        margin-top: 20px;
        /* padding: 20px;
        border: 1px solid #DCDFE6; */
    }
    .centers>.perTab{
        border: 1px solid #DCDFE6;
        margin-bottom: 10px;
        padding: 10px;
    }
    .floatL{
        float: left;
    }
    .floatR{
        float: right;
    }
    .clearfix{
        overflow:hidden;
        _zoom:1;
    }
    .blue{
        color: #a4c2f4;
    }
    .violet, .violet:hover{
        background: rgb(137, 137, 186);
        color: rgb(255, 255, 255);
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Finance/Bill.vue